import Image from "next/image";
import * as React from "react";
import parse from "html-react-parser";
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import {FaQuestion} from "react-icons/fa6";
import {useContext} from "react";
import {Basket} from "../../../../context/basket";
import Pill from "../../../../layout/pill/renderer";


const ProductCard = (props) => {
    let jsonResult, tagsResult = [];
    const tagLine = (typeof props.product.tagline !== 'undefined') ? props.product.tagline : '';
    if (typeof props.product.tooltip_content !== 'undefined') {
        jsonResult = JSON.parse(props.product.tooltip_content);
    }
    if (typeof props.product.tags !== 'undefined') {
        tagsResult = JSON.parse(props.product.tags);
    }
    const basket = useContext(Basket);
    const storeData = basket?.data?.quote?.store;
    const name = (typeof props.product.non_medical_name !== 'undefined' &&
        (!basket?.data?.logged_in || !basket?.data?.consultation)) ? props.product.non_medical_name : props.product.name;

    return <Box className="product-inner-card">
                <Grid container>
                    <Grid xs={11}>
                        <h3 className="no-margin">{name}</h3>
                    </Grid>
                    <Grid xs={1}>
                        <Box className="hover">
                            <a className="pointer block bg-dk-grey bg-hover-primary radius-50 lt-grey padding-small-top-3 padding-small-bottom-5 padding-small-x-4" style={{width: 14, height: 14}} onClick={() => props.flipCard()} title="Flip for product information">
                                <span><FaQuestion/></span>
                            </a>
                        </Box>
                    </Grid>
                </Grid>
        <Box className="item-description">
            {parse(tagLine) || ''}
        </Box>
        {Object.keys(tagsResult).length > 0 && (
                <Grid container className="margin-top-1">
                    {Object.values(tagsResult).map((item) => (
                        <Pill label={item} className="bg-darken-lt-grey" hover="#F0FAD7" key={'pill-' + props.product.id + item} />
                    ))}
                </Grid>
            )}

            <Box className="margin-y-1 image-container">
                {props.product.images[0]?.file_path !== null && (
                    <Image
                        width={props.product.images[0]?.width}
                        height={props.product.images[0]?.height}
                        src={props.product.images[0]?.file_path}
                        alt={props.product.name}
                        sizes="100vw"
                        quality={90}
                        priority={1}
                    />
                )}
            </Box>
            {typeof props.oneOffItem !== 'undefined'
                && props.oneOffItem === true
                && props?.product?.prices[0]?.price > 0
                && (
                    <div className="price-wrapper">
                        <div className="price once-off">
                            + once off {storeData.currency.symbol}{parseFloat(props.product.prices[0].price).toFixed(2)}
                        </div>
                    </div>
            )}
            {typeof props.crossSellChild !== 'undefined'
                && props?.crossSellChild?.prices[0]?.price > 0
                && (
                    <div className="price-wrapper">
                        <div className="price additional-plan">
                            + {storeData.currency.symbol}{parseFloat(props.crossSellChild.prices[0].price).toFixed(2)} every {props.crossSellChild.name}
                        </div>
                    </div>
            )}
            {typeof props.shouldShowPrice !== 'undefined'
                && props.shouldShowPrice
                && props.basket?.data?.quote?.store?.currency
                && props.product.prices?.[0]
                && (
                    <div className="price-wrapper">
                        <span className="primary price once-off">
                            + once off
                            {basket?.data?.quote?.store?.currency.symbol}
                            {props.product.prices[0].price.toFixed(2)}
                        </span>
                    </div>
                )}

    </Box>
}

export default ProductCard;